import React from "react";
import { Row, Col, Card, Button } from "antd";
import moment from "moment";

const SubscriptionDetail = props => {
  return (
    <div style={{ marginTop: 30, marginBottom: 250 }}>
      <Row style={{ marginTop: 20 }}>
        <Col span={6}>
          {props.subscription &&
          props.subscription.status === "active" ? (
            <h3>Subscription</h3>
          ) : null}
        </Col>
        <Col span={16} offset={2}>
          {props.subscription &&
          props.subscription.status === "active" ? (
            <>
              {props.subscription &&
              props.subscription.cancel_at_period_end &&
              props.subscription.status === "active" ? (
                <p style={{ color: "red" }}>
                  {`Your account is set to deactivate on ${moment(
                    props.subscription.cancel_at * 1000
                  ).format("MM/DD/YYYY")}`}
                </p>
              ) : null}
              <Card style={{ width: "100%" }}>
                <Row>
                  <Col span={18} push={6}>
                    <p>{props.subscription.account_name}</p>
                  </Col>
                  <Col span={6} pull={18}>
                    <strong>Account Name:</strong>
                  </Col>
                </Row>
              </Card>
              <Card style={{ width: "100%" }}>
                <Row>
                  <Col span={18} push={6}>
                    <p>{props.subscription.plan_name}</p>
                  </Col>
                  <Col span={6} pull={18}>
                    <strong>Plan:</strong>
                  </Col>
                </Row>
              </Card>
              <Card style={{ width: "100%" }}>
                <Row>
                  <Col span={18} push={6}>
                    <p>{`$${props.subscription.amount / 100}`}</p>
                  </Col>
                  <Col span={6} pull={18}>
                    <strong>Price:</strong>
                  </Col>
                </Row>
              </Card>
              <Card style={{ width: "100%" }}>
                <Row>
                  <Col span={18} push={6}>
                    <p>
                      {moment(
                        props.subscription.subscription_created * 1000
                      ).format("MM/DD/YYYY")}
                    </p>
                  </Col>
                  <Col span={6} pull={18}>
                    <strong>Plan Start Date:</strong>
                  </Col>
                </Row>
              </Card>
            </>
          ) : null}

          {props.subscription &&
          props.subscription.status === "active" &&
          !props.subscription.cancel_at_period_end ? (
            <Button
              type="danger"
              ghost
              onClick={() => props.cancelSubscription(props.subscription, true)}
              size="large"
              style={{ marginTop: 20, width: 200 }}
            >
              Cancel Subscription
            </Button>
          ) : null}
          {props.subscription &&
          props.subscription.cancel_at_period_end &&
          props.subscription.status === "active" ? (
            <Button
              ghost
              type="primary"
              onClick={() =>
                props.cancelSubscription(props.subscription, false)
              }
              size="large"
              style={{ marginTop: 20, width: 200 }}
            >
              Resubscribe
            </Button>
          ) : null}
        </Col>
      </Row>
    </div>
  );
};

export default SubscriptionDetail;
